import { callApi } from 'utils/api';
import { setAuthData } from 'authStore';

export function authLogin({ userName, passWord, location = null }) {
  let body = { userName, passWord };

  if(location) {
    body = {...body, location};
  }

  return callApi('/auth/login', {
    method: 'POST',
    body
  })
  .then(json => {
    setAuthData(json);
    return json;
  });
}

export function authTokenRefresh() {
  return callApi('/auth/token-refresh', {
    method: 'POST'
  })
  .then(json => {
    setAuthData(json);
    return json;
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/auth/api.js
 **/